import { Injectable, inject } from '@angular/core';
import { HttpService } from '@nha/api/shared';
import { CoreApiConfiguration } from '../core-api-configuration.class';

import { lastValueFrom, of, take, tap } from 'rxjs';
import { appSettings } from '@nha/config';

@Injectable({
	providedIn: 'root'
})
export class FeatureFlagService extends HttpService {
	constructor() {
		const config = inject(CoreApiConfiguration);

		super(config, 'featureflag');
	}

	async loadFeatureFlags(): Promise<void> {
		const cachedFlags = localStorage.getItem(`feature-flags`);
		if (cachedFlags) {
			await lastValueFrom(of(JSON.parse(cachedFlags))).then((flags) => {
				appSettings.featureFlags = flags;
			});
			this.loadFromBackend();
		} else {
			await this.loadFromBackend();
		}
	}

	private loadFromBackend(): Promise<void> {
		const cachedFlags = localStorage.getItem(`feature-flags`);
		return lastValueFrom(
			this.http.get<string[]>(this.serviceUrl).pipe(
				take(1),
				tap((flagsFromDB) => {
					// update cached settings
					cachedFlags !== JSON.stringify(flagsFromDB) && this.updateCachedFeatureFlags(flagsFromDB);
				})
			)
		).then((flags) => {
			appSettings.featureFlags = flags;
		});
	}

	private updateCachedFeatureFlags(flags: string[]) {
		localStorage.setItem(`feature-flags`, JSON.stringify(flags));
	}
}
